<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yFGE4W/Images/cover.jpg?1706297464850" alt="This image is the cover for the book Mad Bomber of New York"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mad Bomber of New York
      </h1>
      <p class="bookDescription body article font2">
        <b>“Gripping and bizarre . . . A compelling account of a dangerously angry man and the investigation that helped to revolutionize modern police work.” —<i>Kirkus Reviews</i></b><br/><br/><b></b><br/><br/>Between 1940 and 1957, thirty-three bombs—strategically placed in Grand Central Terminal, Penn Station, Radio City Music Hall, Macy’s, and other crowded areas of New York—paralyzed the city, sending shockwaves of fear through the public.<br/><br/>George Metesky, the “Mad Bomber,” unleashed a reign of terror that reverberated through America’s social, legal, and political landscape, ultimately spurring the birth of modern criminal profiling when a psychiatrist was called in to assist in the manhunt. A compelling work of historical true crime, <i>The Mad Bomber of New York</i> is the gripping tale of two individuals engaged in a deadly game of hide-and-seek, with the city of New York caught in the crosshairs.<br/><br/>“A full-fledged biography that evokes the chaos and media circus that the terrorist, George P. Metesky, engendered.” —<i>The New York Times</i><br/><br/>“Masterfully told . . . a first-rate true-crime story.” —Scott Christianson, author of <i>Bodies of Evidence</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael M. Greenburg
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sterling
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0af0f841